import { SectionHeading } from '@/components/ui'
import {
  type Insights,
  useCheckTransactions,
  useInsights,
} from '@/modules/projects'
import { ChecksInsights } from '../components'

export function ChecksInsightsPage() {
  const insights = useInsights() as Insights
  const checks = useCheckTransactions()

  // A freshly generated project always carries a summary (with zero counts when
  // it has no checks), so it renders normally below. Only insights generated
  // before checks joined the pipeline land here (the column defaults to {}); we
  // can't tell those apart from a genuinely check-free project without
  // regenerating, so the copy reads naturally for the no-checks case and offers
  // regeneration as an aside.
  if (!insights?.checks?.summary) {
    return (
      <SectionHeading
        title="Checks"
        description="No checks to show for this project. If checks were added since the last analysis, regenerate insights to include them."
      />
    )
  }

  return <ChecksInsights checkInsights={insights.checks} checks={checks} />
}
